import React, { Component } from 'react';
import KeyboardKeySeattle from './KeyboardKeySeattle';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux';
import { shallowEqual, presetDp, dp } from '../../../utils/shared.js'
import donorHelpers from '../../../utils/donorHelpers.js'
import dataHelpers from '../../../utils/dataHelpers.js'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import StorySeattle from './StorySeattle';
import BRSpan from '../../General/BRSpan';

class UserInputSeattle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: "",
      module: this.props.item,
      virtual_keyboard_mode: 0,
      iScrollInitialized: false,
      scrollContainerHeight: 0.5625 * this.props.regionWidth,
      storyRefs: [],
      hideKeyboard: false,
      emailSent: false,
      showStory: false,
      renderedStories: [],
      renderedDonors: []
    }

    this._donorListNames = [];
    this._storiesRefs = [];
    this._backButtonRef = null;
    this.iScroller = null;
    this._simple = null;
    this._simpleWithPictures = null;
    this._videos = null;
    this._donors = null;
    this._pills = null;
    this._resultsContainer = null;
    this._emailSentTimeout = null;
    this._pillsStorySetsByModules = [];
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.deleteText = this.deleteText.bind(this);
    this.normalMode = this.normalMode.bind(this);
    this.capitalMode = this.capitalMode.bind(this);
    this.submitText = this.submitText.bind(this);

    this.getTimelineModule();

    //Refs
    this._storyPillsRefs = [];
  }

  // componentWillMount() {
  //   checkData(this.props.item, this.props.screen.entry_point);
  //   this._emailSentTimeout = null;
  //   clearTimeout(this._emailSentTimeout);
  // }

  componentDidMount() {
    setTimeout(() => {
      this._donorListNames = this.setupDonorListsNames();
    }, 2500);
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (shallowEqual(this.state, prevState)) {
      return false;
    }
    return true;
  }

  handleKeyPress(val) {
    if (typeof val === "function") {
      val();
    }
    else {
      let str = this.state.text + val;
      if (str.length < 40) {
        this.setState({
          text: str
        })
      }
    }
  }

  normalMode() {
    this.setState({
      virtual_keyboard_mode: 0
    })
  }

  capitalMode() {
    this.setState({
      virtual_keyboard_mode: 1
    })
  }

  deleteText() {
    if (this.state.text.length > 0) {
      let str = this.state.text.substring(0, this.state.text.length - 1);
      this.setState({
        text: str
      })
    }
  }

  submitText() {
    this.setState({
      iScrollInitialized: false
    })

    this._pillsStorySetsByModules = [];
    this._storyPillsRefs = [];
    this._storyPillsRefs.length = 0;

    let donorResults = donorHelpers.searchInFolderDonorLists(this.props.content.story_categories, this.props.donors, this.state.text);
    let storiesResult = dataHelpers.searchStory(this.props.content, this.state.text, ['attract_loop']);
    this.renderStories(storiesResult);
    this.renderDonors(donorResults);

    this.setState({
      stories: storiesResult,
      donors: this._donors,
      hideKeyboard: true
    });

    setTimeout(() => {
      this.setState({
        search: true
      });
      setTimeout(() => {
        this.iScroller._iScrollInstance.refresh();
      }, 500)
    }, 500);
  }

  getTimelineModule = () => {
    this._menuModules = _.filter(this.props.content.dm_active, { module_contents: { in_navigation: true } });
    this._menuModules.forEach((module, row) => {
      if (module.display_module_type === "Timeline") {
        this._timelineModule = module;
      }
    });
  }

  setupDonorListsNames = () => {
    let folders = _.filter(this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_list" } } } } });
    let names = [];
    if (folders && folders.length > 0) {
      for (let i = 0; i < folders.length; i++) {
        let searchable = _.get(folders[i], 'contents.custom_fields.searchable.val', false);
        if (searchable) {
          let folder = folders[i];
          let folderTree = this.getFolderTree(folder, 0);          
          let name = "";
          let subName = "";
          let parentId = null;
          let parent;

          if (folderTree.count <= 4) {
            let child = folderTree.child;
            while(child) {
              if (child.child) {
                child = child.child;
                parent = { ...child };
              } else {
                name = child.name;
                parentId = parent.parent_category;
                child = null;
              }
            }

            names.push({
              id: folder.id,
              name: name,
              subName: null,
              parentId: parentId
            });
          }

          if (folderTree.count === 5) {
            let child = folderTree.child;
            while(child) {
              if (child.child) {
                name = child.name;
                child = child.child;
                parent = { ...child };
              } else {
                subName = child.name;
                parentId = parent.parent_category;
                child = null;
              }
            }

            names.push({
              id: folder.id,
              name: name,
              subName: subName,
              parentId: parentId
            });
          }
        }
      }
    }

    return names;
  }

  getFolderTree = (folder, count) => {
    count++;
    if (folder.parent_category === undefined || folder.parent_category === null) {
      folder.count = count;
      return folder;
    } else {
      let parentFolder = _.find(this.props.content.story_categories, { id: folder.parent_category });
      parentFolder.child = folder;
      return this.getFolderTree(parentFolder, count);
    }
  }

  removeInputText = () => {
    this.setState({
      text: "",
      search: false
    });
    setTimeout(() => {
      this.setState({
        hideKeyboard: false
      });
    }, 500)
  }

  initializeIScroll = () => {
    if (this.state.iScrollInitialized === false) {
      for (let i = 0; i < this._storiesRefs.length; i++) {
        if (this._storiesRefs[i] && this._storiesRefs[i].el) {
          this._storiesRefs[i].el.addEventListener("tap", () => this.handleTap(this._storiesRefs[i].data.id));
        }
      }

      this.setState({
        iScrollInitialized: true
      })
    }
  }

  setupBackButtonRef = () => {
    if (this._backButtonRef) {
      this._backButtonRef.addEventListener('click', () => this.handleBackButtonClick());
    } else {
      setTimeout(() => {
        this.setupBackButtonRef();
      }, 100)
    }
  }

  handleBackButtonClick = () => {
    if (this._backButtonRef) {
      this._backButtonRef.removeEventListener('click', () => this.handleBackButtonClick());
    }
    this._storiesRefs = [];
    this._backButtonRef = null;
    this.setState({
      showStory: false,
      story: null,
      iScrollInitialized: false
    });
  }

  handleTap = (storyId) => {
    let story = _.find(this.props.content.stories, { id: storyId });
    this.setState({
      story: story,
      showStory: true
    });
    setTimeout(() => {
      this.setupBackButtonRef();
    }, 200);
  }

  getDonorListName = (folder) => {
    let name = _.find(this._donorListNames, { id: folder.id });
    return name;
  }

  getGrouppedDonorFolders = (folders) => {
    let parents = []
    for (let i = 0; i < folders.length; i++) {
      let name = this.getDonorListName(folders[i]);
      if (name && parents.indexOf(name.parentId) === -1) {
        parents.push(name.parentId);
      }
    }

    return parents;
  }

  getTributes = (donor) => {
    let renderedTributes = []
    if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
      renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map((opt, i) => {
        return (
          <div key={i}>
            <div style={{ paddingTop: this.props.regionWidth * .0035, paddingBottom: this.props.regionWidth * .0035  }}>{`${opt.acknowledgment_text_options.val.title} ${opt.donor_name.val}`}</div>
          </div>
        );
      });
    }

    return renderedTributes;
  }

  renderStories = (stories) => {
    if (stories.length === 0) {
      this.setState({
        renderedStories: []
      });
      return;
    }

    let rows = [];
    let row = [];
    for (let i = 0; i < stories.length; i++) {
      let slide = stories[i];
      let image = presetDp('stories', _.get(slide, 'contents.images[0]', null), this.props.screen);
      let marginLeft = 0;
      
      if (i > 0 && (i % 3 !== 0)) {
        marginLeft = 0.0225 * this.props.regionWidth;
      } else {
        marginLeft = 0;
      }
      
      if ((i % 3 === 0 && i > 0)) {
        rows.push(row);
        row = [];
      }

      let story = (
        <div key={i} ref={el => this._storiesRefs[i] = { el: el, data: { id: slide.id } }} style={{ position:"relative", marginLeft: marginLeft, float:"left", height:0.09 * this.props.regionWidth, display:"flex", justifyContent:"center", alignItems:"flex-end", minWidth:"25%", maxWidth:"25%" }}>
          <img src={image} style={{ maxWidth:0.10125 * this.props.regionWidth, maxHeight:0.074925 * this.props.regionWidth }} alt=""/>
          <div style={{ position: "absolute", bottom: -(0.0468 * this.props.regionWidth), width: 0.10125 * this.props.regionWidth, textAlign: "center", display: "flex", justifyContent: "center", minHeight: 0.04166666666666666667 * this.props.regionWidth, maxHeight: 0.04166666666666666667 * this.props.regionWidth, overflow: "hidden" }}>
            <div style={{ fontSize: 0.0084 * this.props.regionWidth }}><BRSpan preWrap str={slide.name.toUpperCase()}/></div>
          </div>
        </div>
      );

      row.push(story);
      if (i === stories.length - 1) {
        rows.push(row);
      }
    }

    let renderedRows = rows.map((row, j) => {
      let marginTop = j === 0 ? 0 : this.props.regionWidth * 0.017;
      return (
        <div key={j} style={{ position:"relative", display:"flex", alignItems:"center", justifyContent:"center", width: "89%", height:0.10125 * this.props.regionWidth, marginTop: marginTop, left: this.props.regionWidth * 0.041 }}>
          {row}
        </div>
      );
    });

    this.setState({
      renderedStories: renderedRows
    });
  }

  renderDonors = (results) => {
    let renderedDonors = [];
    let renderedSubDonors = [];
    let count = 0;
    let marginTop = 0;

    let foundFolders = _.filter(this.props.content.story_categories, fl => results.foundFolders.indexOf(Number(fl.id)) > -1);
    let parents =  this.getGrouppedDonorFolders(foundFolders);
    let parentFolders = _.filter(this.props.content.story_categories, fl => parents.indexOf(Number(fl.id)) > -1);

    for (let i = 0; i < parentFolders.length; i++) {
      let children = _.filter(foundFolders, { parent_category: parentFolders[i].id });
      for (let j = 0; j < children.length; j++) {
        let folder = children[j];
        let searchable = _.get(folder, 'contents.custom_fields.searchable.val', false);
        if (searchable) {
          let categoryMatchedDonors = _.orderBy(_.filter(results.foundDonors, { folder_module: { folder: folder.id } }), [donor => donor.sorting_name.toLowerCase()], ['asc']);
          let matchedColumnOne = [];
          let matchedColumnTwo = [];
  
          // Highlighted Donors (matched)
          for (let k = 0; k < categoryMatchedDonors.length; k++) {
            if (k === 0 || k % 2 === 0) {
              matchedColumnOne.push(categoryMatchedDonors[k]);
            } else {
              matchedColumnTwo.push(categoryMatchedDonors[k]);
            }
          }
  
          let renderedMatchedColumnOneDonors = matchedColumnOne.map((donor, i) => {
            let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * this.props.regionWidth : 0;
            return (
              <div key={i} style={{ width: "100%", textAlign: "left", minHeight: 0.013 * this.props.regionWidth, display: "block", paddingTop: .0052 * this.props.regionWidth }}>
                <div style={{ maxWidth: "85%", fontSize: 0.009 * this.props.regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
                <div style={{ marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * this.props.regionWidth }}>
                  {this.getTributes(donor)}
                </div>
              </div>
            );
          });
  
          let renderedMatchedColumnTwoDonors = matchedColumnTwo.map((donor, i) => {
            let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * this.props.regionWidth : 0;
            return (
              <div key={i} style={{ width: "100%", textAlign: "left", minHeight: 0.013 * this.props.regionWidth, display: "block", paddingTop: .0052 * this.props.regionWidth }}>
                <div style={{ maxWidth: "85%", fontSize: 0.009 * this.props.regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
                <div style={{ marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * this.props.regionWidth }}>
                  {this.getTributes(donor)}
                </div>
              </div>
            );
          });
  
          let donorCategoryName = this.getDonorListName(folder);
          let { subName } = donorCategoryName;
          if (count > 0) {
            marginTop = .026 * this.props.regionWidth;
          }
  
          renderedSubDonors[j] = (
            <div key={j}>
              {
                subName ?
                <div style={{ fontSize: this.props.regionWidth * 0.009, paddingTop: 0.00347222222222222222 * this.props.regionWidth, paddingBottom: 0.00694444444444444444 * this.props.regionWidth }}>
                  <BRSpan preWrap str={subName.toUpperCase()} />
                </div>
                :null
              }
              <div style={{ position: "absolute", height: this.props.regionWidth * 0.0017, background: "white", width: "90%" }} />
              <div style={{ position: "relative", width: "100%", display: "flex", marginTop: .004 * this.props.regionWidth, marginBottom: 0.0086 * this.props.regionWidth }}>
                <div style={{ width: 0.16875 * this.props.regionWidth, float: "left" }}>
                  {renderedMatchedColumnOneDonors}
                </div>
                <div style={{ width: 0.16875 * this.props.regionWidth }}>
                  {renderedMatchedColumnTwoDonors}
                </div>
              </div>
            </div>
          );
        }
      }

      renderedDonors[i] = (
        <div key={i} style={{ position: "relative", left: this.props.regionWidth * 0.060, marginTop: marginTop }}>
          <div style={{ fontSize: this.props.regionWidth * 0.015625 }}><BRSpan preWrap str={parentFolders[i].name.toUpperCase()}/></div>
          {renderedSubDonors}
        </div>
      );
      renderedSubDonors = [];
    }

    this.setState({
      renderedDonors: renderedDonors
    });
  }

  render() {
    const iconImage = dp(this.props.screen, null, { path:'/img/seattle/general/', file_name:'icon-search-header.png' });

    let keystd = {
      width: this.props.regionWidth * 0.0260,
      height: this.props.regionWidth * 0.0260,
      margin: this.props.regionWidth * 0.0015,
      borderRadius: this.props.regionWidth * 0.005,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize: this.props.regionWidth * 0.015,
      color:"black"
    }

    let keyspace = {
      width: this.props.regionWidth * 0.0950,
      height: this.props.regionWidth * 0.0260,
      margin: this.props.regionWidth * 0.0015,
      borderRadius: this.props.regionWidth * 0.005,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize: this.props.regionWidth * 0.015,
    }

    let keycom = {
      width: this.props.regionWidth * 0.0430,
      height: this.props.regionWidth * 0.0260,
      margin: this.props.regionWidth * 0.0015,
      borderRadius: this.props.regionWidth * 0.005,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize: this.props.regionWidth * 0.015,
    }

    let keysubmit = {
      width: this.props.regionWidth * 0.11,
      height: this.props.regionWidth * 0.0260,
      margin: this.props.regionWidth * 0.0015,
      borderRadius: this.props.regionWidth * 0.005,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize: this.props.regionWidth * 0.015,
    }

    const textAlign = this.state.text.length > 0 ? "center" : "left";

    // let boxStyle = {
    //   paddingLeft: '3.375vh',
    //   paddingRight: '3.375vh',
    //   paddingTop: '1.96875vh',
    //   paddingBottom: '1.96875vh',
    //   width: "100%"
    // }

    //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.

    if (!this.props.item) {
      return <span />
    }

    const backButton = dp(this.props.screen, null, { path:'/img/seattle/general/', file_name:'back.png' });
    const hasMatchedResults = this.state.renderedStories.length > 0 || this.state.renderedDonors.length > 0;
    return (
      <div>
        {/* Screen */}
        <div style={{ position: "absolute", width: "100%", height:"100%" }} >
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '45%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showStory}>
            {
              !this.state.showStory ?
              <div style={{ position:"absolute", left: this.props.regionWidth * .038 }}>
                <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
                  <img alt={this.props.item.contents.header} src={iconImage} style={{ width: 0.18 * this.props.regionWidth }} />
                </div>
                <div style={{ textAlign: "center", fontSize: this.props.regionWidth * 0.034 }}>
                  {this.props.item.contents.header.toUpperCase()}
                </div>
                <div style={{ fontSize: this.props.regionWidth * 0.014, textAlign: "center" }}>
                  {this.props.item.contents.text}
                </div>

                <div style={{ height: this.props.regionWidth * 0.02 }} />
                  <div style={{ display: "flex", justifyContent: "center", alignItems:"center" }}>
                  <div style={{ display: 'flex', width: this.props.regionWidth * 0.3246, height: 0.04 * this.props.regionWidth, border: .0035 * this.props.regionWidth, borderStyle: "solid", borderColor: "#FFFFFF", justifyContent:"center", alignItems:"center" }}>
                    <span style={{ height:this.props.regionWidth * 0.041, display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: 0.018 * this.props.regionWidth, color: "white", float: "left", width: "90%" }}>
                      {
                        this.state.text.length > 0 ?
                          <div>&nbsp;{this.state.text}&nbsp;</div>
                          : <div style={{ fontSize: 0.028 * this.props.regionWidth, fontWeight: "bold" }}>
                          </div>
                      }
                    </span>
                    <span onClick={this.removeInputText} style={{ height: .027 * this.props.regionWidth, fontSize: this.props.regionWidth * .0225, color: "white", fontWeight: "bold" }}>
                      <FontAwesome name='times' />
                    </span>
                  </div>
                </div>
              </div>
              : null
            }
          </div>
          </CSSTransitionGroup>

          {/* Keyboard */}
          <CSSTransitionGroup
            component='div'
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.hideKeyboard}>
            {
              !this.state.hideKeyboard && !this.state.showStory ?
              <div style={{ color: 'black', width: '85%', height: .3375 * this.props.regionWidth, display: "block", marginLeft: "auto", marginRight: "auto", }}>
                <div className="helem" style={{ position: "relative", paddingTop: .0225 * this.props.regionWidth }}>
                  <div>
                    <KeyboardKeySeattle keyval={[1, 1, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[1, 1, null]} />
                    <KeyboardKeySeattle keyval={[2, 2, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[2, 2, null]} />
                    <KeyboardKeySeattle keyval={[3, 3, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[3, 3, null]} />
                    <KeyboardKeySeattle keyval={[4, 4, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[4, 4, null]} />
                    <KeyboardKeySeattle keyval={[5, 5, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[5, 5, null]} />
                    <KeyboardKeySeattle keyval={[6, 6, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[6, 6, null]} />
                    <KeyboardKeySeattle keyval={[7, 7, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[7, 7, null]} />
                    <KeyboardKeySeattle keyval={[8, 8, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[8, 8, null]} />
                    <KeyboardKeySeattle keyval={[9, 9, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[9, 9, null]} />
                    <KeyboardKeySeattle keyval={[0, 0, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[0, 0, null]} />
                    <KeyboardKeySeattle keyval={[this.deleteText, this.deleteText, this.deleteText]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['DELETE', 'DELETE', 'DELETE']} />
                    <br />

                    <KeyboardKeySeattle keyval={['q', 'Q', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['q', 'Q', null]} />
                    <KeyboardKeySeattle keyval={['w', 'W', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['w', 'W', null]} />
                    <KeyboardKeySeattle keyval={['e', 'E', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['e', 'E', null]} />
                    <KeyboardKeySeattle keyval={['r', 'R', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['r', 'R', null]} />
                    <KeyboardKeySeattle keyval={['t', 'T', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['t', 'T', null]} />
                    <KeyboardKeySeattle keyval={['y', 'Y', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['y', 'Y', null]} />
                    <KeyboardKeySeattle keyval={['u', 'U', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['u', 'U', null]} />
                    <KeyboardKeySeattle keyval={['i', 'I', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['i', 'I', null]} />
                    <KeyboardKeySeattle keyval={['o', 'O', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['o', 'O', null]} />
                    <KeyboardKeySeattle keyval={['p', 'P', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['p', 'P', null]} />
                    <KeyboardKeySeattle keyval={['@', null, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['@', '@', null]} />
                    <br />

                    <KeyboardKeySeattle keyval={['a', 'A', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['a', 'A', null]} />
                    <KeyboardKeySeattle keyval={['s', 'S', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['s', 'S', null]} />
                    <KeyboardKeySeattle keyval={['d', 'D', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['d', 'D', null]} />
                    <KeyboardKeySeattle keyval={['f', 'F', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['f', 'F', null]} />
                    <KeyboardKeySeattle keyval={['g', 'G', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['g', 'G', null]} />
                    <KeyboardKeySeattle keyval={['h', 'H', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['h', 'H', null]} />
                    <KeyboardKeySeattle keyval={['j', 'J', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['j', 'J', null]} />
                    <KeyboardKeySeattle keyval={['k', 'K', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['k', 'K', null]} />
                    <KeyboardKeySeattle keyval={['l', 'L', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['l', 'L', null]} />
                    <KeyboardKeySeattle keyval={['_', '_', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['_', '_', null]} />
                    <KeyboardKeySeattle keyval={['&', '&', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['&', '&', null]} />
                    <br />

                    <KeyboardKeySeattle keyval={['z', 'Z', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['z', 'Z', null]} />
                    <KeyboardKeySeattle keyval={['x', 'X', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['x', 'X', null]} />
                    <KeyboardKeySeattle keyval={['c', 'C', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['c', 'C', null]} />
                    <KeyboardKeySeattle keyval={['v', 'V', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['v', 'V', null]} />
                    <KeyboardKeySeattle keyval={['b', 'B', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['b', 'B', null]} />
                    <KeyboardKeySeattle keyval={['n', 'N', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['n', 'N', null]} />
                    <KeyboardKeySeattle keyval={['m', 'M', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['m', 'M', null]} />
                    <KeyboardKeySeattle keyval={['.', '.', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['.', '.', null]} />
                    <KeyboardKeySeattle keyval={['-', '-', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['-', '-', null]} />
                    <KeyboardKeySeattle keyval={['*', '*', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['*', '*', null]} />
                    <KeyboardKeySeattle keyval={['?', '?', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['?', '?', null]} />

                    <br />
                    <div style={keystd}><span className="kspn-seattle">=/#</span></div>
                    <KeyboardKeySeattle keyval={[this.capitalMode, this.normalMode, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['UPCASE', 'DOWNCASE', null]} />
                    <KeyboardKeySeattle keyval={[' ', ' ', ' ']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keyspace} contents={['Space', 'Space', 'Space']} />
                    <KeyboardKeySeattle keyval={['.com', '.com', '.com']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keycom} contents={['.com', '.com', '.com']} />
                    <KeyboardKeySeattle searchStr={this.searchStr} keyval={['Submit', 'Submit', 'Submit']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.submitText} mainstyle={keysubmit} contents={['Submit', 'Submit', 'Submit']} />
                  </div>
                </div>
              </div>
              : null
            }
            </div>
          </CSSTransitionGroup>

          <CSSTransitionGroup
            component='div'
            className="containerFade"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.search} style={{ position:"absolute", width: "90%", marginLeft: "auto", marginRight: "auto", height: .27225 * this.props.regionWidth, touchAction: "none", top: 0.017 * this.props.regionWidth }}>
              {
                this.state.search && !this.state.showStory ?
                <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
                  options={{
                    mouseWheel: true,
                    scrollbars: false,
                    scrollX: false,
                    scrollY: true,
                    probeType: 2,
                    bounce: false,
                    momentum: true,
                    deceleration: 0.015,
                    useTransition: true,
                    disableTouch: false,
                    disablePointer: false,
                    disableMouse: false,
                    tap: true
                  }}
                  onRefresh={this.initializeIScroll}
                >
                  <div style={{ position: "relative" }}>
                    {
                      this.state.renderedStories && this.state.renderedStories.length > 0 ?
                      <div style={{ height:this.props.regionWidth * 0.0347 }}>
                        <span style={{ marginLeft:this.props.regionWidth * 0.046875, fontSize: this.props.regionWidth * 0.015625 }}>STORIES</span>
                        <div style={{ position:"absolute", height: this.props.regionWidth * 0.0017, background:"white", width:"90%", left: this.props.regionWidth * 0.039 }}/>  
                      </div>
                      :null
                    }
                    {
                      this.state.renderedStories && this.state.renderedStories.length > 0 ?
                      this.state.renderedStories : null
                    }
                    
                    {
                      this.state.renderedStories && this.state.renderedStories.length > 0
                      && this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                      <div style={{ width:"100%", height:this.props.regionWidth * 0.034 }}></div>
                      : null
                    }
                    
                    {
                      this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                      <div style={{ height:this.props.regionWidth * 0.0347 }}>
                        <span style={{ marginLeft:this.props.regionWidth * 0.046875, fontSize: this.props.regionWidth * 0.015625 }}>DONOR LIST</span>
                        <div style={{ position:"absolute", height: this.props.regionWidth * 0.0017, background:"white", width:"90%", left: this.props.regionWidth * 0.039 }}/>
                      </div>
                      :null
                    }
                    {
                      this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                      this.state.renderedDonors : null
                    }

                    {
                      !hasMatchedResults ?
                      <div style={{ width: "100%", height:"100%", textAlign:"center", marginTop: this.props.regionWidth * .021, paddingLeft: this.props.regionWidth * .013 }}>
                        Sorry, no results matching <br/> "{`<${this.state.text}>`}"
                        <br/><br/>
                        <img onClick={() => this.removeInputText()} src="/img/seattle/general/search.png" style={{ width: this.props.regionWidth * .086 }} alt=""/>
                      </div>
                      : null
                    }

                    <div style={{ height: .03375 * this.props.regionWidth }} />
                  </div>
                </ReactIScroll>
                  : null
              }
            </div>
          </CSSTransitionGroup>
        </div>

        {/* Modal */}
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          {
              this.state.showStory ?
              <div style={{ position:"absolute", left: 0, width:"100%", height: .52 * this.props.regionWidth }}>
                <div>
                  <StorySeattle
                    item={this.state.story}
                    screen={this.props.screen}
                    regionWidth={this.props.regionWidth}
                    handleSwipeAnimation={this.props.handleSwipeAnimation}
                    cancelSwipeAnimation={this.props.cancelSwipeAnimation}
                  />
                  <img ref={reactComponent => this._backButtonRef = reactComponent} src={backButton} style={{ position:"absolute", left:0, top: .45138888888888888889 * this.props.regionWidth, width:0.050625 * this.props.regionWidth }} alt=""/>
                </div>
              </div>
              :null
            }
        </CSSTransitionGroup>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    screen: state.screen,
    content: state.content,
    donors: state.donors,
  };
};

export default connect(mapStateToProps, null)(UserInputSeattle);


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/UserInputSeattle.jsx